class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    const poster = this.querySelector('[data-deferred-media-button]');
    poster?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.theme.pauseAllMedia();

    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);

      const mediaElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) mediaElement.focus();
      if (mediaElement.nodeName == 'VIDEO' && mediaElement.getAttribute('autoplay')) {
        // Force autoplay on Safari browsers
        mediaElement.play();
      }
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}

window.theme.DeferredMedia = window.theme.DeferredMedia || DeferredMedia;
